module.exports = __webpack_public_path__ + "img/02卖车.51b56926.jpg";